
// src/components/landing/VettingSystemSection.tsx
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Shield, BrainCircuit, FileCheck, UserCheck } from "lucide-react";
import Image from 'next/image';

const vettingPillars = [
  {
    icon: <Image src="https://firebasestorage.googleapis.com/v0/b/zamzi-connect.firebasestorage.app/o/TRUSTSVG.svg?alt=media&token=d216d687-9494-4986-bb91-b61314921317" alt="AI Forensics Icon" width={40} height={40} />,
    title: "AI-Powered Document Forensics",
    description: "Our system's first gatekeeper. We use advanced AI to perform an initial forensic analysis on every uploaded document, trained to detect digital tampering, screen captures, and signs of forgery to instantly flag suspicious files.",
  },
  {
    icon: <Image src="https://firebasestorage.googleapis.com/v0/b/zamzi-connect.firebasestorage.app/o/CHECKSVG.svg?alt=media&token=3e20394a-00da-4f0e-9aac-96c277b83151" alt="Compliance Check Icon" width={40} height={40} />,
    title: "Compliance & Identity Audit",
    description: "Beyond forensics, our AI Auditor cross-references document details with the user's profile. It verifies names, and ensures the document type is correct, ensuring both authenticity and relevance.",
  },
  {
    icon: <Image src="https://firebasestorage.googleapis.com/v0/b/zamzi-connect.firebasestorage.app/o/HUMANSVG.svg?alt=media&token=2961f227-fc62-4bea-95e0-1874e6cb7105" alt="Manual Review Icon" width={40} height={40} />,
    title: "Expert Manual Review",
    description: "Technology is powerful, but context is key. If our AI flags an issue, our dedicated compliance team steps in. This human oversight is our commitment to fairness, accuracy, and getting it right.",
  },
];

export function VettingSystemSection() {
  return (
    <section className="py-16 md:py-24" style={{ backgroundColor: '#f2f8f2' }}>
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold mb-4 text-primary">
            Trust is Our Foundation. Verification is Our Proof.
          </h2>
          <p className="text-lg max-w-3xl mx-auto text-muted-foreground">
            We've built a proprietary, multi-layered vetting system to ensure the professionals and businesses you connect with are legitimate and trustworthy.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {vettingPillars.map((pillar, index) => (
            <Card key={index} className="text-center shadow-lg hover:shadow-xl hover:-translate-y-2 transition-all duration-300 border-none">
              <CardHeader className="flex flex-col items-center">
                {pillar.icon}
                <CardTitle
                  className="text-xl font-semibold mt-4"
                  style={{ color: "#001489" }}
                >
                  {pillar.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground">{pillar.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
